import { useRegionStore } from '@packages/stores';

import { Button } from '@elements/button';
import { Notification } from '@elements/notification';
import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { openModalSelector, useModalStore } from '@store';

import { TripCostInput } from './tripCostInput.component';

export const TripCostEditor = () => {
  const isUS = useRegionStore(state => state.region?.country === 'US');

  const openModal = useModalStore(openModalSelector);

  const handleInfoButtonClick = () => {
    return openModal('Modal', {
      titleProps: {
        children: i18n.t('tripCost.modal.title'),
      },
      bodyTextProps: {
        children: i18n.t('tripCost.modal.content'),
      },
      actions: [
        {
          variant: 'primary',
          title: i18n.t('tripCost.modal.actions.ok'),
          onClick: () => useModalStore.getState().closeModal(),
        },
      ],
      size: 'lg',
    });
  };

  if (!isUS) return null;

  return (
    <div className="flex flex-col gap-s16 pb-s16">
      <div className="flex items-center gap-s2">
        <Text onClick={handleInfoButtonClick} variant="h3-28/sb">
          {i18n.t('tripCost.title')}
        </Text>
        <Button variant="tertiary" icon="info" size="sm" onClick={handleInfoButtonClick} />
      </div>
      <Text>{i18n.t('tripCost.description')}</Text>
      <Notification
        header={i18n.t('tripCost.notification.title')}
        body={i18n.t('tripCost.notification.content')}
      />
      <TripCostInput />
    </div>
  );
};
